import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useNavigate } from 'react-router-dom'
import { Box, Button, LinearProgress, Typography } from '@mui/material'
import SchoolIcon from '@mui/icons-material/School'

import {
  selectClassCompletionStatus,
  selectCourseID,
  selectCurrentQuizQuestion,
  selectQuiz,
  quizRestarted,
} from '../classroom.slice'
import QuizQuestion from './quiz-question'
import QuizFinalResults from './quiz-final-results'

export default () => {
  let dispatch = useAppDispatch()
  let navigate = useNavigate()
  let quiz = useAppSelector(selectQuiz)
  let step = useAppSelector(selectCurrentQuizQuestion)
  let courseID = useAppSelector(selectCourseID)
  let classCompletionStatus = useAppSelector(selectClassCompletionStatus)

  useEffect(() => {
    dispatch(quizRestarted())
  }, [])

  return (
    <div>
      <LinearProgress
        variant="determinate"
        value={
          quiz?.questions?.length
            ? (step * 100) / (quiz?.questions?.length ?? 0)
            : 0
        }
      />
      {classCompletionStatus?.status === 'completed' ? (
        <Box
          sx={{
            m: 4,
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 2,
          }}
        >
          <div></div>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography gutterBottom variant="subtitle1" component="div">
              <SchoolIcon /> Return to Course Page
            </Typography>
            <Typography variant="body2" gutterBottom>
              This class is one of the many classes in the course. You have
              completed this one so there is no need to take the quiz. You may
              return to the course page to continue with the next class.
            </Typography>
            <div className="flex flex-row-reverse">
              <Button
                variant="contained"
                onClick={() => navigate(`/self-paced/course/${courseID}`)}
              >
                Return to Course Page
              </Button>
            </div>
          </Box>
        </Box>
      ) : step === quiz.questions.length ? (
        <QuizFinalResults />
      ) : (
        quiz?.questions?.map((_, i) => (
          <div style={{ display: i === step ? 'block' : 'none' }}>
            <QuizQuestion />
          </div>
        ))
      )}
    </div>
  )
}
